import { sign } from './sign'
const API = import.meta.env.VITE_API_BASE || window.location.origin

export async function gTranslate(text, target, ctx = 'websuperadmin') {
  const { translations } = await gTranslateBatch([text], target, ctx)
  return translations[0]
}

export async function gTranslateBatch(texts = [], target, ctx = 'websuperadmin', retry = 3) {
  if (!texts.length) return { translations: [] }
  const body = JSON.stringify({ texts, target, ctx })
  const sig  = await sign(body)
  try {
    const res = await fetch(`${API}/translate/batch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-KZY-Sig': sig },
      body,
      credentials: 'include',
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      throw new Error(err.detail || `http_${res.status}`)
    }
    return await res.json()
  } catch (e) {
    if (retry > 0) {
      await new Promise(r => setTimeout(r, 300 * 2 ** (3 - retry)))
      return gTranslateBatch(texts, target, ctx, retry - 1)
    }
    throw e
  }
}

export async function gTranslateMulti(text, targets = 'all', ctx = 'websuperadmin', retry = 3) {
  const body = JSON.stringify({ text, targets, ctx })
  const sig  = await sign(body)
  try {
    const res = await fetch(`${API}/translate/multi`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-KZY-Sig': sig },
      body,
      credentials: 'include',
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      throw new Error(err.detail || `http_${res.status}`)
    }
    return await res.json()
  } catch (e) {
    if (retry > 0) {
      await new Promise(r => setTimeout(r, 300 * 2 ** (3 - retry)))
      return gTranslateMulti(text, targets, ctx, retry - 1)
    }
    throw e
  }
}
